<template>
  <div class="sub-page-v2">
    <div class="page-hero-small">
      <h1>{{ $t('common.about') }}</h1>
    </div>
    <div class="container-v2 page-body-v2">
      <SubNavV2 :items="navItems" />
      <router-view />
    </div>
  </div>
</template>

<script>
import SubNavV2 from '@/components/SubNavV2.vue'

export default {
  name: 'AboutIndexV2',
  components: { SubNavV2 },
  data() {
    return {
      navItems: [
        { nameKey: 'common.profile', path: '/about/profile' },
        { nameKey: 'common.structure', path: '/about/structure' },
        { nameKey: 'common.history', path: '/about/history' },
        { nameKey: 'common.business', path: '/about/business' },
        { nameKey: 'common.honors', path: '/about/honors' }
      ]
    }
  }
}
</script>
